const style = (theme) => {
  const output = {
    root: {},
    wrapper: {
      extend: theme.wrapper,
    },
    line: {
      width: '100%',
      height: 1,
      background: theme.colors[6],
      marginTop: 20,
      marginBottom: 20,
      transform: 'scaleX(0)',
      transformOrigin: 'left',
    },
    titleWrapper: {
      position: 'relative',
    },
    titleHidden: {
      fontFamily: theme.fonts[1],
      fontWeight: 700,
      fontSize: 60,
      textTransform: 'uppercase',
      letterSpacing: '2px',
    },
    title: {
      fontFamily: theme.fonts[1],
      fontWeight: 700,
      fontSize: 60,
      lineHeight: 1,
      textTransform: 'uppercase',
    },
    hidden: {
      opacity: 0,
      position: 'absolute',
      top: 0,
      left: 0,
      pointerEvents: 'none',
    },
    removeOverflow: {
      overflow: 'visible',
    },
    backBtn: {
      opacity: 0,
      marginBottom: 40,
      position: 'relative',
      zIndex: 2,
    },
    denomination: {
      fontSize: 24,
      lineHeight: 1,
      textTransform: 'uppercase',
    },
    denominationHidden: {
      fontSize: 24,
      textTransform: 'uppercase',
      letterSpacing: '2px',
    },
    subtitle: {
      fontSize: 16,
      lineHeight: 1,
    },
    mediaBox: {
      marginTop: 80,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      '& img:first-child': {
        width: '50%',
      },
    },
    lastImage: {
      maxHeight: 280,
      maxWidth: '45%',
    },
  }

  output[theme.mediaInverse.md] = {
    lastImage: {
      maxHeight: 150,
    },
  }

  output[theme.mediaInverse.sm] = {
    content: {
      padding: '0 6vw',
    },
    titleWrapper: {
      flexDirection: 'column',
    },
    backBtn: {
      order: -1,
      marginBottom: 20,
    },
    titleHidden: {
      fontSize: 32,
    },
    title: {
      fontSize: 32,
    },
    denominationHidden: {
      fontSize: 17,
    },
    denomination: {
      fontSize: 17,
    },
    subtitle: {
      fontSize: 12,
    },
    mediaBox: {
      marginTop: 20,
      flexDirection: 'column',
      alignItems: 'center',
      '& img:first-child': {
        width: '90%',
      },
    },
    lastImage: {
      maxWidth: '80%',
      maxHeight: '100%',
    },
  }

  return output
}

export default style
